import { useEffect, useState } from 'react';
import { errorResults, IerrorResult } from './processFiles';

export const ErrorList = ({ errors }: { errors: errorResults }) => {

    const [activeErrors, setactiveErrors] = useState<any[]>([])

    const [activeFileWithErrors, setactiveFileWithErrors] = useState('')

    useEffect(() => {
        console.log({errors})
    }, [errors])
    

    const onClickFileWithError = (fileName: string) => {

        if (activeFileWithErrors === fileName) {
            setactiveErrors([])
            setactiveFileWithErrors('')
        } else {
            const warning: any[] = errors[fileName].filter((e: any) => e.type === 'warning')
            const error: any[] = errors[fileName].filter((e: any) => e.type === 'error')

            setactiveFileWithErrors(fileName)
            setactiveErrors([...error, ...warning])
        }

    }

    return (
        <div className="error_messages_container">
            {Object.keys(errors).map((key, i) => (
                <div key={`${i}_error`}>
                    <div key={i} onClick={() => onClickFileWithError(key)} className="file_row">
                        <div className="name_file_with_errors">
                            <div> {key}</div>
                            <div className="file_row_error_warning_icons">
                                <div className="element_error">
                                    <img src={"/assets/icons/error.svg"} alt='Well Whisper' height={15} width={15} />
                                    {` Errores: ${errors[key].filter((e: any) => e.type === 'error')?.length}`}
                                </div>
                                <div className="element_error">
                                    <img src={"/assets/icons/warnings.svg"} alt='Well Whisper' height={15} width={15} />
                                    {` Alertas: ${errors[key]?.filter((e: any) => e.type === 'warning')?.length}`}
                                </div>
                            </div>
                        </div>
                        <img src={`${activeFileWithErrors === key ? "/assets/icons/arrow_up.svg" : "/assets/icons/arrow_down.svg"}`} alt='Well Whisper' height={35} width={35} />
                    </div>
                    {key === activeFileWithErrors && (
                        <div className="errorMessage_container" key={`${i}_error_container`}>
                            {activeErrors.map((error: any, i: number) => (
                                <div key={i} className={`element ${error.type === "error" ? "error_row" : "warning_row"}`}>
                                    <div>{error.error}</div>
                                    <img src={`${error.type === "error" ? "/assets/icons/error.svg" : "/assets/icons/warnings.svg"}`} alt='Well Whisper' height={15} width={15} />
                                </div>
                            ))}
                        </div>
                    )}

                </div>

            ))}
        </div>
    )
}
